<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="8px">
  <mat-spinner diameter="24"></mat-spinner>
  <h4 class="font-weight-regular">{{ text }}</h4>
</div>
